var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticStyle:{"justify-content":"center","text-align":"center"},attrs:{"inset":true,"app":""}},[_c('span',[_vm._v("© d-meeting depa")])])
}
var staticRenderFns = []

export { render, staticRenderFns }